<header class="header">
    <div class="container-fluid">
        <div class="navbar d-flex justify-content-between p-0">
            <div class="brand-wrap d-flex align-items-center">
                <a href="/" class="logo">
                    <img src="https://www.mylifewell.com/assets/images/logo/300.png" alt="logo">
                </a>
                
            </div>
            <ul class="profile-wrap d-flex">
                <li class="inner-profile position-md-static">
                    <ul class=" d-flex justify-content-center justify-content-md-end ">
<!--                        <li>-->
<!--                            <a href="javascript:void(0)">-->
<!--                                <i class="icon-search"></i>-->
<!--                            </a>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <a href="javascript:void(0)" class="cart-wrap d-flex">-->
<!--                                <i class="icon-bell"></i>-->
<!--                                <span class="notify-count text-center d-flex align-items-center justify-content-center"><small>3</small></span>-->
<!--                            </a>-->
<!--                        </li>   -->
                    </ul>
                </li>
                <li class="profile-content d-flex align-items-center" id="user-settings-menu">
                  <a class="d-flex align-items-center"  (click)="showprofilemenu($event, 'user-setting')" >
                    <span class="red-circle cursorHand">
                        <img [src]="imgSrc" alt="profile image">
                    </span>
                    <span class="profile-name d-none d-md-block" *ngIf="userDetails">
                        {{userDetails.firstName}}
                    </span>
                  </a>
                  <ul class="user-setting  text-left d-none" id="user-setting" *ngIf="globalService.isLoggedIn">
                    <li><a href="/" class="cursorHand">Home</a></li>
                    <li><a href="/myaccount/schedule" class="cursorHand">My Account</a></li>
                    <li><a (click)="logOut()" class="cursorHand">Log Out</a></li>
                  </ul>

                </li>

                <li>
                    <a routerLink="./" class="cart-wrap d-flex">
                        <i class="icon-cart"></i>
                        <span class="notify-count text-center d-flex align-items-center justify-content-center">
                            <small>{{globalService.cartquantity}}</small>
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</header>
